module.exports = __webpack_public_path__ + "img/heating-disabled.c247a225.png";